import { FormikErrors, FormikProps, withFormik } from 'formik'
import { t } from 'i18next'
import React, { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from '@lib/formik'

import { Button } from '@ui/components/Button'

import { FormSubmitValues } from '@utils/formValidation'

import { usePasswordValidation } from '@global/PasswordValidation/PasswordValidation'
import { createFormPasswordField } from '@global/formField/FormPasswordField'

import { Box } from '@shared/components/Box'
import { FieldWrapper } from '@shared/components/FieldWrapper'

import { ResetPasswordCompleteFormValues, ResetPasswordFormValues } from './ResetPassword.page'

import styles from './ForgotPasswordPage.module.scss'

const FormField = createFormPasswordField<ResetPasswordFormValues>()

const ResetPasswordFormCompleteUI: React.FC<FormikProps<ResetPasswordFormValues> & OuterProps> = (
  props
) => {
  const { handleSubmit, setSubmitting, isSubmitting, isValid, dirty, values, email, token } = props
  const { password, confirmPassword } = values

  const { isPasswordValid, validationComponent } = usePasswordValidation({
    password,
    confirmPassword,
    passwordResetData: { email, token },
  })

  const { t } = useTranslation()

  const handleSubmitForm = (event: SyntheticEvent) => {
    event.preventDefault()
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <Form className={styles.form} onSubmit={handleSubmitForm}>
      <FieldWrapper>
        <FormField
          name='password'
          type='password'
          autoComplete='new-password'
          showLabel={true}
          label={t('New Password')}
          required
        />
        <FormField
          name='confirmPassword'
          type='password'
          autoComplete='new-password'
          showLabel={true}
          label={t('Confirm Password')}
          required
        />
      </FieldWrapper>
      <div className={styles.resetPasswordValidationRulesWrapper}>{validationComponent}</div>
      <Box mt='x16' fullWidth>
        <Button.Primary
          size='lg'
          type='submit'
          fullWidth
          disabled={!(isValid && dirty && isPasswordValid)}
          loading={isSubmitting}
        >
          {t('Reset Password')}
        </Button.Primary>
      </Box>
    </Form>
  )
}

interface OuterProps {
  onSubmit(values: FormSubmitValues<ResetPasswordFormValues>): Promise<void>
  email: string
  token: string
}

export const ResetPasswordFormComplete = withFormik<OuterProps, ResetPasswordFormValues>({
  mapPropsToValues: () => {
    return {
      password: '',
      confirmPassword: '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<ResetPasswordCompleteFormValues> = {}
    if (!values.password) {
      errors.password = t('Validation.Required')
    }
    return errors
  },
  enableReinitialize: true,
})(ResetPasswordFormCompleteUI)
